import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';


export default class Orderslist extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Orders
                </div>
                <div className="admindashboard__section__content">
                    {(this.props.data && this.props.data.length >= 1) &&
                        <div className="admindashboard__section__content__table admindashboard__section__content__table--orders">

                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Trip ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Seller ID
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Seller username
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Amount gross
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Status
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Created
                            </div>

                            {this.props.data.map((el, i) => (
                                <React.Fragment key={i}>
                                    <div onClick={() => this.props.setTrip(el.trip_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {el.trip_id ? el.trip_id : "-"}
                                    </div>
                                    <div onClick={() => this.props.setUser(el.seller_user_id)} className="admindashboard__section__content__table__element admindashboard__section__content__table__element--link">
                                        {el.seller_user_id ? el.seller_user_id : "-"}
                                    </div>
                                    <Link to={"/u/" + el.seller_username} className="admindashboard__section__content__table__element">
                                        {el.seller_username ? el.seller_username : "-"}
                                    </Link>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.payment.amount_total_gross ? el.payment.amount_total_gross : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.status ? el.status : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {format_date_technical(el.created)}
                                    </div>
                                </React.Fragment>
                            ))}

                        </div>
                    }
                </div>
            </div>
        )
    }
}